import { render } from "./CalendarDay.vue?vue&type=template&id=08091915&scoped=true"
import script from "./CalendarDay.vue?vue&type=script&lang=js"
export * from "./CalendarDay.vue?vue&type=script&lang=js"

import "./CalendarDay.vue?vue&type=style&index=0&id=08091915&scoped=true&lang=css"

import exportComponent from "/home/runner/work/nutristudents-k12-container/nutristudents-k12-container/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08091915"]])

export default __exports__